module.exports = __webpack_public_path__ + "img/diners.9c4cb6fd.svg";